module.exports = __webpack_public_path__ + "static/22_tat3-6f488f8877e867f5f5d0dc78abe957a1.jpg";